import { CurrentClientIntakeResponseState } from './currentClientIntakeResponse.firebase.state';

export class CurrentClientIntakeResponseSelectors {
	static readonly _props = CurrentClientIntakeResponseState._props;

	static readonly $getCurrentClientIntakeResponse =
		CurrentClientIntakeResponseState._props.clientIntakeResponse;
}
